module.exports = __webpack_public_path__ + "static/media/ic_freeehand_selected.23d0861e.svg";